import React from 'react'
import { Products } from '../components'

function Produits() {
	return <Products />
}

export default Produits
